import { Box, Tab, Tabs, useTheme,
  //  Dialog
   } from "@material-ui/core";
import React, { ChangeEvent, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ALL_SEASONS } from "src/constants";
import { ISeasonTabs } from "./types";
import { hexToRGB } from "src/util";
// import { last } from "lodash";
import axios from "axios";
import { useEffect } from "react";
import VideoModal from "src/components/videoModal";
export const SeasonTabs = ({ schoolSlug, seasons, forVideoMidSeson, ...rest }: ISeasonTabs) => {
  const theme = useTheme();
  const location = useLocation();
  const history = useHistory();
  // const seasonOnInitialRender = [{ name: ALL_SEASONS }, ...seasons].find(
  //   (season) => season.name === last(location?.pathname?.split("/") ?? [])
  // )?.name;


  const pathSegments = location?.pathname?.split("/") ?? [];
// pathSegments: ["", "KVS1733984828128", "dashboard", "FALL", "2025", "322"]

const seasonFromUrl = pathSegments[pathSegments.indexOf("dashboard") + 1]; 
// "FALL"

const seasonOnInitialRender = [{ name: ALL_SEASONS }, ...seasons].find(
  (season) => season.name === seasonFromUrl
)?.name;
  const [value, setValue] = useState(seasonOnInitialRender);
  const [openVideo, setOpenVideo] = useState(false);
  const [videoUrl, setVideoUrl] = useState("http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4");

  const handleChange = async (_: ChangeEvent, newValue: string) => {
    setValue(newValue);
    if (newValue === "video") {
      await fetchVideoUrl();
      setOpenVideo(true);
    } else {
      history.push(`/${schoolSlug}/dashboard/${newValue}`);
    }
  };

  useEffect(() => {
    console.log("isMeadSeason", forVideoMidSeson);

  }, []);
  const fetchVideoUrl = async () => {
    try {
      const res = await axios.get("/video/getOneVideo/1");
      console.log("videoooooooo", res)
      if (res.status === 200 && res.data?.file) {
        setVideoUrl(res.data.file);
        setOpenVideo(true);
      }
    } catch (error) {
      console.error("Failed to fetch video:", error);
    }
  };

  // const handleVideoClose = () => setOpenVideo(false);

  const opaquePrimary = `rgba(${hexToRGB(theme.palette.primary.main)}, 0.1)`;

  return (
    <Box marginBottom="1.5rem" {...rest}>
      <Box
    
        style={{
          backgroundColor: opaquePrimary,
          borderRadius: "4px",
          display:"flex",
          justifyContent:"space-between",
        }}>
      <Tabs
        indicatorColor="primary"
        onChange={handleChange}
        textColor="primary"
        value={value}
      >
       
        <Tab label={ALL_SEASONS} value={ALL_SEASONS} />
        {seasons.map((season) => (
          <Tab key={season.id} label={season.name} value={season.name} />
        ))}


         </Tabs>

      <Tabs
        indicatorColor="primary"
        onChange={handleChange}
        textColor="primary"
        value={value}
      >

      {forVideoMidSeson &&    <Tab label="Video" value="video"/>
    }
</Tabs>
</Box>
{forVideoMidSeson &&

      // <Dialog open={openVideo} onClose={handleVideoClose} maxWidth="md">
      //   <Box p={2}>
      //     {videoUrl ? (
      //       <video width="100%" controls={true}>
      //         <source src={videoUrl} type="video/mp4" />
      //         Your browser does not support the video tag.
      //       </video>
      //     ) : (
      //       <p>Loading video...</p>
      //     )}
      //   </Box>
      // </Dialog>
   <VideoModal videoURL={videoUrl} open={openVideo} handleClose={() => {
       setOpenVideo(false)
      }} />
}
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/season-tabs/SeasonTabs.tsx